import { inject, observer } from 'mobx-react';
import React from 'react';
import { Card, CardContent, Grid, GridColumn, List, ListItem, Separator, Text } from 'telia-front-react';
import RouteStore from '../stores/RouteStore';
import SearchStore from '../stores/SearchStore';
import { TranslationsContext } from '@teliaee/telia-translate';

interface SearchNotFoundResultsProps {
  searchStore?: SearchStore;
  routeStore?: RouteStore;
  onlyShopSearch?: boolean;
  isMobile?: boolean;
}

@observer
class SearchNotFoundResults extends React.Component<SearchNotFoundResultsProps> {
  static contextType = TranslationsContext;
  declare context: React.ContextType<typeof TranslationsContext>;

  public render() {
    const translate = this.context.translate;
    const {
      searchStore: { query },
      onlyShopSearch,
      isMobile
    } = this.props;

    if (!query) {
      return null;
    }

    return (
      <>
        <Text className="text-center">
          {onlyShopSearch ? translate('search.wasFoundInShop') : translate('search.wasFound')}
          <strong>
            {' 0 '}
            {translate('search.results')}{' '}
          </strong>
          <>{translate('search.forSearch')} </>"<strong>{query}</strong>".
        </Text>
        <Separator spacing="xsmall" color="invisible" />
        <Grid align={['center-xs']}>
          <GridColumn width={['xs-12', 'md-10', 'lg-9', 'xl-7']}>
            <Card type="light" padding={isMobile ? 'small' : 'large'} background="neutral-bg-level-1">
              <CardContent>
                <p className="h5 text-bold text-left">{translate('search.searchSuggestions.title')}</p>
                <Separator spacing="xsmall" color="invisible" />
                <List className="text-left" type="icon" icon="#check">
                  {[...Array(3).keys()].map((suggestionNumber) => (
                    <ListItem key={`no-result-suggestion-${suggestionNumber}`}>{translate(`search.searchSuggestions.${suggestionNumber}`)}</ListItem>
                  ))}
                </List>
              </CardContent>
            </Card>
          </GridColumn>
        </Grid>
      </>
    );
  }
}

export default inject('searchStore', 'routeStore')(SearchNotFoundResults);
